// =============================================================================
// PARTS4DRIVE CORPORATE HEADQUARTERS & PHYSICAL VERIFICATION ADDRESS
// Single Source of Truth for Physical Presence, Google Maps CID & Routing
// =============================================================================

export interface CompanyAddressConfig {
  readonly companyName: string;
  readonly organizationName: string;
  readonly legalName: string;
  readonly addressLine1: string;
  readonly streetAddress: string;
  readonly plusCode: string;
  readonly fullPlusCode: string;
  readonly locality: string;
  readonly city: string;
  readonly region: string;
  readonly state: string;
  readonly postalCode: string;
  readonly country: string;
  readonly countryCode: string;
  readonly fullAddress: string;
  readonly latitude: number;
  readonly longitude: number;
  readonly coordinates: { readonly lat: number; readonly lng: number };
  readonly ludocid: string;
  readonly googlePlaceCid: string;
  readonly googleSearchUrl: string;
  readonly googleBusinessProfileUrl: string;
  readonly googleMapsCidUrl: string;
  readonly googleMapsUrl: string;
  readonly googleMapsSearchUrl: string;
  readonly googleDirectionsUrl: string;
  readonly openStreetMapEmbedUrl: string;
  readonly supportPhone: string;
  readonly phone: string;
  readonly whatsappNumber: string;
  readonly whatsappDisplayPhone: string;
  readonly whatsappCountry: string;
  readonly whatsappDirectUrl: string;
  readonly whatsappChannelUrl: string;
  readonly supportEmail: string;
  readonly email: string;
  readonly openingHours: string;
}

const lat = 5.8493625;
const lng = 7.1506719;
const cid = '17360960825668728625';
const googleSearch = 'https://www.google.com/search?sca_esv=b25d32625954c6d5&sxsrf=APpeQnuSHznZNhkrqcV8B5md3fFOFehzeg:1790925131504&q=parts4drive+address&ludocid=17360960825668728625&sa=X&ved=2ahUKEwjv56CC5JqXAxWKUkEAHWDRCNIQ6BN6BAgiEAI';
const googleMapsCid = 'https://maps.google.com/?cid=17360960825668728625';
const googleMapsSearch = 'https://www.google.com/maps/search/?api=1&query=R5X2%2BP7V,+Orlu+475109,+Imo,+Nigeria';

export const COMPANY_ADDRESS: CompanyAddressConfig = {
  companyName: 'Parts4Drive',
  organizationName: 'Parts4Drive Technologies Inc.',
  legalName: 'NGiSense Technologies, Inc. (Parts4Drive Technologies)',
  addressLine1: 'R5X2+P7V, Orlu Commercial Corridor',
  streetAddress: 'R5X2+P7V, Orlu Commercial Corridor',
  plusCode: 'R5X2+P7V, Orlu',
  fullPlusCode: '6FQ9R5X2+P7V',
  locality: 'Orlu',
  city: 'Orlu',
  region: 'Imo',
  state: 'Imo State',
  postalCode: '475109',
  country: 'Nigeria',
  countryCode: 'NG',
  fullAddress: 'R5X2+P7V, Orlu 475109, Imo, Nigeria',
  latitude: lat,
  longitude: lng,
  coordinates: { lat, lng },
  ludocid: cid,
  googlePlaceCid: cid,
  googleSearchUrl: googleSearch,
  googleBusinessProfileUrl: googleSearch,
  googleMapsCidUrl: googleMapsCid,
  googleMapsUrl: googleMapsCid,
  googleMapsSearchUrl: googleMapsSearch,
  googleDirectionsUrl: googleMapsSearch,
  openStreetMapEmbedUrl:
    'https://www.openstreetmap.org/export/embed.html?bbox=7.135%2C5.835%2C7.165%2C5.865&layer=mapnik&marker=5.8493625%2C7.1506719',
  supportPhone: '+447456048829',
  phone: '+44 7456 048829',
  whatsappNumber: '+447456048829',
  whatsappDisplayPhone: '+44 7456 048829',
  whatsappCountry: 'United Kingdom',
  whatsappDirectUrl: 'https://wa.me/447456048829',
  whatsappChannelUrl: 'https://whatsapp.com/channel/0029Vb9W9nFBA1f4pS5xUL3L',
  supportEmail: 'support@parts4drive.com',
  email: 'support@parts4drive.com',
  openingHours: 'Mo-Sa 08:00-18:00 WAT',
};
